import FaiTypography from "MuiComponents/FaiTypography";
import FaiBox from "MuiComponents/FaiBox";
import { Button, Card, Divider, Grid } from "@mui/material";
import FormField from "components/FormField";
import DataList from "screens/Catalog/Inventory/component/DataList";
import categoryDetaildata from "../data/categoryDetailData";
import BackIcon from "components/AppIcons/BackIcon";
import { useEffect, useState } from "react";
import Axios from "services/api/config";
import {
	getCategories,
	createSubCategory,
	getProductTypes,
	updateMasterCategory,
	updateSubCategory,
	deleteSubCategory,
} from "services/api/routes/Admin";
import FaiButton from "MuiComponents/FaiButton";
import { toast } from "sonner";
import FaiSelect from "MuiComponents/FaiSelect";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { DropzoneArea } from "material-ui-dropzone";
import { Formik } from "formik";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

export default function CategoryDetail({ category, setCategory }) {
	const [state, setState] = useState({
		categories: [],
		loading: false,
		productTypes: [],
		loadingProductTypes: false,
	});

	const [categoryName, setcategoryName] = useState("");
	const [selectedProductType, setSelectedProductType] = useState<any>();
	const [creating, setCreating] = useState(false);
	const [selectedExcelFile, setSelectedExcelFile] = useState<File | null>(null);

	// Simplified file state management
	const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
	const [selectedImageUrls, setSelectedImageUrls] = useState<string[]>([]);

	// const handleSetCategoryImages = (files: File[], urls: string[]) => {
	// 	setSelectedFiles(files);
	// 	setSelectedImageUrls(urls);
	// };

	const [editSubCategory, setEditSubCategory] = useState(null);
	const [editSubCategoryName, setEditSubCategoryName] = useState("");
	const [editSubCategoryImage, setEditSubCategoryImage] = useState(null);
	const [editLoading, setEditLoading] = useState(false);
	const [removeLoading, setRemoveLoading] = useState(false);
	const [removeSubCategory, setRemoveSubCategory] = useState(null);

	const handleCreateSubcategory = async () => {
		try {
			if (!categoryName) {
				toast.error("Subcategory name is required");
				return;
			}
			if (!selectedProductType?.value) {
				toast.error("Product type is required");
				return;
			}
			if (!selectedExcelFile) {
				toast.error("Excel file is required");
				return;
			}
			if (selectedFiles.length === 0) {
				toast.error("Subcategory image is required");
				return;
			}

			setCreating(true);
			const subCategoryFormData = new FormData();
			subCategoryFormData.append("name", categoryName);
			subCategoryFormData.append("masterCategoryId", category.id);
			subCategoryFormData.append("productTypeId", selectedProductType.value);
			subCategoryFormData.append("templateExcelMedia", selectedExcelFile);

			// Add all selected images
			selectedFiles.forEach((file, index) => {
				subCategoryFormData.append("media", file);
			});

			await Axios({
				...createSubCategory,
				data: subCategoryFormData,
				headers: {
					"Content-Type": "multipart/form-data",
				},
			});

			toast.success("Sub-category created successfully");
			setSelectedFiles([]);
			setSelectedImageUrls([]);
			setcategoryName("");
			fetchSubCategories();
			setSelectedExcelFile(null);
		} catch (error) {
			console.error(error);
		} finally {
			setCreating(false);
		}
	};

	const handleEditSubCategory = (row) => {
		setEditSubCategory(row);
		setEditSubCategoryName(row.name);
		setEditSubCategoryImage(null);
	};

	const handleRemoveSubCategory = (row) => {
		setRemoveSubCategory(row);
	};

	const handleEditSubCategorySubmit = async () => {
		try {
			setEditLoading(true);
			const formData = new FormData();
			formData.append("name", editSubCategoryName);
			if (editSubCategoryImage) {
				formData.append("media", editSubCategoryImage);
			}
			await Axios({
				...updateSubCategory(editSubCategory.id),
				data: formData,
				headers: { "Content-Type": "multipart/form-data" },
			});
			toast.success("Sub-category updated successfully");
			setEditSubCategory(null);
			fetchSubCategories();
		} catch (error) {
			toast.error("Failed to update sub-category");
			console.error(error);
		} finally {
			setEditLoading(false);
		}
	};

	const handleRemoveSubCategoryConfirm = async () => {
		try {
			setRemoveLoading(true);
			await Axios({ ...deleteSubCategory(removeSubCategory.id) });
			toast.success("Sub-category removed successfully");
			setRemoveSubCategory(null);
			fetchSubCategories();
		} catch (error) {
			toast.error("Failed to remove sub-category");
			console.error(error);
		} finally {
			setRemoveLoading(false);
		}
	};

	const fetchSubCategories = async () => {
		try {
			setState((prev) => ({ ...prev, loading: true }));
			const { data: categoryRes } = await Axios({
				...getCategories(category.id),
			});
			if (categoryRes.data && categoryRes?.data?.categories) {
				setState((prev) => ({
					...prev,
					categories: categoryRes?.data?.categories || [],
				}));
			}
		} catch (error) {
			console.error(error);
		} finally {
			setState((prev) => ({ ...prev, loading: false }));
		}
	};

	const fetchProductTypes = async () => {
		try {
			setState((prev) => ({ ...prev, loadingProductTypes: true }));
			const { data: productTypesRes } = await Axios({
				...getProductTypes(),
			});
			if (productTypesRes?.data) {
				setState((prev) => ({
					...prev,
					productTypes:
						productTypesRes.data.data.map((type) => ({
							label: type.name,
							value: type.id,
						})) || [],
				}));
			}
		} catch (error) {
			console.error(error);
			toast.error("Failed to fetch product types");
		} finally {
			setState((prev) => ({ ...prev, loadingProductTypes: false }));
		}
	};

	useEffect(() => {
		fetchSubCategories();
		fetchProductTypes();
	}, []);

	return (
		<Card className="my-6 p-3 md:p-6">
			<FaiBox className={"inventory"}>
				<Button
					startIcon={<BackIcon />}
					onClick={() => setCategory()}
					className="!p-1 text-theme !mb-2"
				>
					Go Back
				</Button>
				<FaiBox mb={2}>
					<FaiTypography
						variant="h4"
						className="!text-xl !font-semibold"
					>
						Master Category: {category.Category}
					</FaiTypography>
				</FaiBox>
                <Formik
                  initialValues={{
                    name: category.name || "",
                    description: category.description || "",
                    status: category.status || "ACTIVE",
                    media: null,
                  }}
                  enableReinitialize
                  onSubmit={async (values, { setSubmitting, resetForm }) => {
                    try {
                      if (!values.name) {
                        toast.error("Category name is required");
                        return;
                      }
                      setCreating(true);
                      const formData = new FormData();
                      formData.append("name", values.name);
                      formData.append("description", values.description || "");
                      formData.append("status", values.status);
                      if (values.media) {
                        formData.append("media", values.media);
                      }
                      await Axios({
						...updateMasterCategory(category.id),
                        data: formData,
                        headers: { "Content-Type": "multipart/form-data" },
                      });
                      toast.success("Master category updated successfully");
                    //   if (typeof setCategory === "function") setCategory(null); // Go back to list
                    } catch (error) {
                      toast.error("Failed to update master category");
                      console.error(error);
                    } finally {
                      setCreating(false);
                      setSubmitting(false);
                    }
                  }}
                >
                  {({ values, setFieldValue, handleChange, handleSubmit, isSubmitting, dirty }) => (
                    <form onSubmit={handleSubmit} style={{ width: "100%" }}>
                      <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} sm={4}>
                          <FormField
                            label="Category Name"
                            name="name"
                            placeholder="Enter Category Name"
                            value={values.name}
                            onChange={handleChange}
                            isRequired
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <FaiBox>
                            <FaiTypography
                              component="label"
                              variant="caption"
                              className="!text-base !font-medium !mb-2"
                              isRequired
                            >
                              Status
                            </FaiTypography>
                            <FaiSelect
                              name="status"
                              options={[
                                { label: "Active", value: "ACTIVE" },
                                { label: "Inactive", value: "INACTIVE" },
                              ]}
                              value={{ label: values.status === "ACTIVE" ? "Active" : "Inactive", value: values.status }}
                              onChange={(option:any) => setFieldValue("status", option.value)}
                            />
                          </FaiBox>
                        </Grid>
						<Grid item xs={12} sm={4}>
                          <FaiBox>
                            <FaiTypography
                              component="label"
                              variant="caption"
                              className="!text-base !font-medium !mb-2"
                            >
                              Category Image
                            </FaiTypography>
                            <FaiBox display="flex" alignItems="center" gap={2}>
                              {category.media && !values.media && (
                                <img src={category.media} alt="Current" style={{ height: 50, width: 50, objectFit: "cover", borderRadius: 4 }} />
                              )}
                              <input
                                type="file"
                                accept="image/*"
                                style={{ display: "none" }}
                                id="update-category-media"
                                onChange={e => {
                                  if (e.target.files && e.target.files[0]) {
                                    setFieldValue("media", e.target.files[0]);
                                  }
                                }}
                              />
                              <label htmlFor="update-category-media">
                                <FaiButton variant="outlined" component="span">
                                  {values.media ? values.media.name : "Change Image"}
                                </FaiButton>
                              </label>
                              {values.media && (
                                <img
                                  src={URL.createObjectURL(values.media)}
                                  alt="Preview"
                                  style={{ height: 50, width: 50, objectFit: "cover", borderRadius: 4 }}
                                />
                              )}
                            </FaiBox>
                          </FaiBox>
                        </Grid>
                        <Grid item xs={12}>
                          <FormField
                            label="Description"
                            name="description"
                            placeholder="Enter Description"
                            value={values.description}
                            onChange={handleChange}
                            multiline
                            rows={3}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                          {dirty && (
                            <FaiButton
                              type="submit"
                              variant="contained"
                              color="primary"
                              disabled={isSubmitting || creating}
                            >
                              {isSubmitting || creating ? "Updating..." : "Update Category"}
                            </FaiButton>
                          )}
                        </Grid>
                      </Grid>
                    </form>
                  )}
                </Formik>
				<Divider className="!my-2" />
				<Grid container spacing={2}>
					<Grid item xs={12} sm={6}>
						<FormField
							label={"Sub-category Name"}
							name={"subcategoryName"}
							placeholder={"Enter Sub-category"}
							value={categoryName}
							onChange={(e) => setcategoryName(e.target.value)}
							isRequired
						/>
					</Grid>
					<Grid item xs={12} sm={6}>
						<FaiBox>
							<FaiTypography
								component="label"
								variant="caption"
								className="!text-base !font-medium !mb-2"
								isRequired
							>
								Select product type
							</FaiTypography>
							<FaiSelect
								placeholder={"Select product type"}
								name={"productType"}
								options={state.productTypes}
								value={selectedProductType}
								onChange={(value: any) => setSelectedProductType(value)}
								isLoading={state.loadingProductTypes}
								isRequired
							/>
						</FaiBox>
					</Grid>
				</Grid>
				<FaiBox mt={2} xs={12} sm={6}>
					<FaiBox mb={1}>
						<FaiTypography
							component="label"
							variant="caption"
							className="!text-base !font-medium"
							isRequired
						>
							Category Image
						</FaiTypography>
					</FaiBox>
					{/* <FaiDropzone
						selectedImages={selectedImageUrls}
						setSelectedImages={handleSetCategoryImages}
						note="Upload JPG or PNG files. Max 5MB."
					/> */}
					<DropzoneArea
						onChange={(files) => setSelectedFiles(files)}
						dropzoneText="Drag your file(s) or browse"
						filesLimit={999}
					/>
				</FaiBox>
				<FaiBox mt={2} display="flex" alignItems="center" gap={2}>
					<FaiButton
						variant="contained"
						color="primary"
						onClick={handleCreateSubcategory}
						disabled={creating}
					>
						{creating ? "Creating..." : "Create Sub-category"}
					</FaiButton>
					<FaiBox>
						<FaiBox display="flex" alignItems="center" gap={1}>
							<FaiButton
								color="secondary"
								variant={"contained"}
								component="label"
								htmlFor="excel-upload"
							>
								{"Select Excel File"}
								<input
									type="file"
									hidden
									id="excel-upload"
									accept=".xlsx,.xls"
									key={selectedExcelFile ? "reset" : "file-input"}
									onChange={(e) => {
										const file = e.target.files?.[0];
										if (file) {
											setSelectedExcelFile(file);
										}
										e.target.value = "";
									}}
								/>
							</FaiButton>
							{selectedExcelFile && (
								<FaiBox display="flex" alignItems="center" gap={1}>
									<FaiTypography variant="body2">
										{selectedExcelFile.name}
									</FaiTypography>
									<FaiButton
										variant="text"
										color="error"
										onClick={() => setSelectedExcelFile(null)}
									>
										<FontAwesomeIcon icon={faClose} />
									</FaiButton>
								</FaiBox>
							)}
						</FaiBox>
					</FaiBox>
				</FaiBox>
			</FaiBox>
			<FaiBox className={"inventory-content-body"} mt={3}>
				{state.loading ? (
					<>Loading...</>
				) : (
					<DataList data={categoryDetaildata(state.categories || [], handleEditSubCategory, handleRemoveSubCategory)} />
				)}
			</FaiBox>

			{/* Edit Sub-category Modal */}
			<Dialog open={!!editSubCategory} onClose={() => setEditSubCategory(null)}>
				<DialogTitle>Edit Sub-category</DialogTitle>
				<DialogContent>
					<FormField
						label="Sub-category Name"
						name="editSubCategoryName"
						placeholder="Enter Sub-category Name"
						value={editSubCategoryName}
						onChange={e => setEditSubCategoryName(e.target.value)}
						isRequired
					/>
					<input
						type="file"
						accept="image/*"
						style={{ marginTop: 16 }}
						onChange={e => {
							if (e.target.files && e.target.files[0]) {
								setEditSubCategoryImage(e.target.files[0]);
							}
						}}
					/>
					{editSubCategory && editSubCategory.media && !editSubCategoryImage && (
						<img src={editSubCategory.media} alt="Current" style={{ height: 50, width: 50, objectFit: "cover", borderRadius: 4, marginTop: 8 }} />
					)}
					{editSubCategoryImage && (
						<img src={URL.createObjectURL(editSubCategoryImage)} alt="Preview" style={{ height: 50, width: 50, objectFit: "cover", borderRadius: 4, marginTop: 8 }} />
					)}
				</DialogContent>
				<DialogActions>
					<FaiButton onClick={() => setEditSubCategory(null)} color="secondary">Cancel</FaiButton>
					<FaiButton onClick={handleEditSubCategorySubmit} color="primary" disabled={editLoading}>
						{editLoading ? "Saving..." : "Save"}
					</FaiButton>
				</DialogActions>
			</Dialog>

			{/* Remove Sub-category Confirmation */}
			<Dialog open={!!removeSubCategory} onClose={() => setRemoveSubCategory(null)}>
				<DialogTitle>Remove Sub-category</DialogTitle>
				<DialogContent>
					Are you sure you want to remove this sub-category?
				</DialogContent>
				<DialogActions>
					<FaiButton onClick={() => setRemoveSubCategory(null)} color="secondary">Cancel</FaiButton>
					<FaiButton onClick={handleRemoveSubCategoryConfirm} color="error" disabled={removeLoading}>
						{removeLoading ? "Removing..." : "Remove"}
					</FaiButton>
				</DialogActions>
			</Dialog>
		</Card>
	);
}
